import React from "react";
import { Grid, Typography } from "@mui/material";
import { AppColors } from "../resources/AppColors";

const ErrorPage = ({ message }) => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Typography
        variant="title_bold"
        component="h1"
        sx={{ color: AppColors.PRIMARY, textAlign: "center" }}
      >
        {message}
      </Typography>
    </Grid>
  );
};

export default ErrorPage;
